module.exports = __webpack_public_path__ + "img/open_black_blurred.b8ea7ee2.png";